"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../theme");
const theme_palette_1 = require("../theme.palette");
exports.CSS = {
    container: 'c-SwitchInput',
    label: 'c-SwitchInput__label',
    input: 'c-SwitchInput__input',
    slider: 'c-SwitchInput__slider'
};
const SWITCH_WIDTH = theme_1.DefaultTheme.spacingFactor * 9;
const SWITCH_HEIGHT = theme_1.DefaultTheme.spacingFactor * 3;
const SLIDER_WIDTH = 20;
exports.Style = {
    [exports.CSS.container]: {
        display: 'flex'
    },
    [exports.CSS.label]: {
        position: 'relative',
        display: 'inline-block',
        width: `${SWITCH_WIDTH}px`,
        height: `${SWITCH_HEIGHT}px`,
        margin: '5px'
    },
    [exports.CSS.input]: {
        opacity: 0,
        [`&:checked + .${exports.CSS.slider}`]: {
            'background-color': (0, theme_1.rgba)(theme_palette_1.ColorPaletteBlue.C700, 0.5)
        },
        [`&:checked + .${exports.CSS.slider}:before`]: {
            transform: `translateX(${SWITCH_WIDTH - SLIDER_WIDTH}px)`,
            'background-color': theme_1.DefaultTheme.color.primary
        },
        [`&:focus + .${exports.CSS.slider}`]: {
            outline: `1px solid ${theme_1.DefaultTheme.color.primary}`
        }
    },
    [exports.CSS.slider]: {
        position: 'absolute',
        cursor: 'pointer',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        'background-color': theme_1.DefaultTheme.font.color.disabled,
        transition: '.4s',
        'border-radius': `${SWITCH_WIDTH}px`,
        '&:before': {
            position: 'absolute',
            content: '""',
            height: `${SLIDER_WIDTH}px`,
            width: `${SLIDER_WIDTH}px`,
            top: `-4px`,
            left: 0,
            'background-color': theme_1.DefaultTheme.font.color.white,
            transition: '.4s',
            'border-radius': '50%',
            'box-shadow': theme_1.DefaultTheme.shadow.box.dp2
        }
    }
};
//# sourceMappingURL=switch.input.style.js.map